import ApiService from "@/services/api.service";

const route = 'link-customers-to-contracts';

const Import = {
    add(_module) {
        return new Promise((resolve, reject) => {            
            ApiService.postDownload(route, _module).then(response => {
                resolve({headers: response.headers, data: response.data});
            }, (error) => {
                reject(error);
            });
        });
    }
};

export default Import;